import {Transition} from "@headlessui/react";
import {useState} from "react";
import {XStack} from "../XStack";
import {ChevronForward, ChevronDown} from "@chayka/icons";

type ExpandableBlockProps = {
  label: React.ReactNode;
};

export const ExpandableBlock: React.FC<
  ExpandableBlockProps & React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({className, label, children, ...rest}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className={className} {...rest}>
      <XStack className="gap-1 items-center" onClick={toggleExpanded}>
        <div className="text-sm font-bold">{label}</div>
        {isExpanded ? <ChevronDown size={20} /> : <ChevronForward size={20} />}
      </XStack>
      <Transition show={isExpanded}>
        <div className="origin-top transition duration-200 ease-out data-closed:-translate-y-2 data-closed:opacity-0">
          {children}
        </div>
      </Transition>
    </div>
  );
};
